export const FILTER_OPERATOR = {
    EQUALS: 'EQUALS',
    NOT_EQUALS: 'NOT_EQUALS',
    IN: 'IN',
    NOT_IN: 'NOT_IN',
    BETWEEN: 'BETWEEN',
    GREATER_THAN: 'GREATER_THAN',
    LESS_THAN: 'LESS_THAN',
    LIKE: 'LIKE',
    BEFORE: 'BEFORE',
    AFTER: 'AFTER',
};

/**
 * @deprecated - use FILTER_OPERATORS
 */
export const RANGE_FILTERS_OPERATORS = {
    GREATER: '>',
    LESS: '<',
    BETWEEN: '[]',
};
